import { Helmet } from 'react-helmet-async'

const SEOHead = ({
  title = "Clynox –Management Software India | Affordable",
  description = "Affordable school management software in India. A modern school ERP for attendance, fees, academics, transport and communication.",
  keywords = "school management software, school ERP, education management system, student information system, school administration software, India, affordable, cloud-based, attendance management, fee management, timetable, parent portal, teacher portal, school dashboard",
  image = "https://clynox.com/og-image.jpg",
  url = "https://www.clynox.com/",
  type = "website",
  structuredData = null
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Clynox" />
      <meta property="og:locale" content="en_IN" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Structured Data */}
      {Array.isArray(structuredData)
        ? structuredData.map((item, idx) => (
            <script key={idx} type="application/ld+json">
              {JSON.stringify(item)}
            </script>
          ))
        : structuredData && (
            <script type="application/ld+json">
              {JSON.stringify(structuredData)}
            </script>
          )}
    </Helmet>
  )
}

export default SEOHead
